// extracted by mini-css-extract-plugin
module.exports = {"portalToBodyWrapper":"styles_portalToBodyWrapper__3rwOQ"};